import React from 'react';

const AboutSection = ({ data }) => {
  return (
    <section className="p-80px-tb about-section">
      <div className="container">
        {/* ページヘッダー */}
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h1 className="section-title font-weight-bold m-30px-b">{data.pageTitle}</h1>
            <p className="lead text-muted">{data.pageSubtitle}</p>
            {/* 砂時計のビジュアル */}
            <div className="visual-placeholder m-50px-t">
              <img
                src={process.env.PUBLIC_URL + "/assets/img/preface.png"}
                alt="砂時計が砕けるビジュアル"
                className="img-fluid rounded"
                style={{maxWidth: '600px', width: '100%', height: 'auto'}}
              />
            </div>
          </div>
        </div>

        {/* 代表メッセージ */}
        <div className="row m-100px-t">
          <div className="col-md-12">
            <div className="message-section">
              <div className="text-center m-50px-b">
                <h2 className="display-4">{data.message.title}</h2>
                <h3 className="h3 text-primary m-30px-t">{data.message.subtitle}</h3>
              </div>

              <div className="row align-items-center m-50px-t">
                <div className="col-lg-4 m-30px-b">
                  {/* 代表写真 */}
                  <div className="ceo-image-placeholder">
                    <img
                      src={process.env.PUBLIC_URL + "/assets/img/avater2.jpeg"}
                      alt="代表ポートレート"
                      className="img-fluid rounded-circle"
                      style={{width: '100%', height: 'auto'}}
                    />
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="message-content">
                    <p className="lead m-25px-b">{data.message.greeting}</p>
                    <p className="text-muted m-25px-b">{data.message.content1}</p>

                    <blockquote className="blockquote bg-light p-30px rounded m-30px-tb">
                      <p className="font-weight-bold text-primary m-0">{data.message.highlight}</p>
                    </blockquote>

                    <p className="text-muted m-25px-b">{data.message.content2}</p>
                    <p className="text-muted m-25px-b">{data.message.content3}</p>

                    <div className="signature m-30px-t">
                      <p className="font-weight-bold m-0">{data.message.signature}</p>
                      <p className="text-muted">{data.message.signatureTitle}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;